<template>
  <div
    class="diagnostic-chart-element"
    :style="{
      width: `${elementInfo.width}px`,
      height: `${elementInfo.height}px`,
      left: `${elementInfo.left}px`,
      top: `${elementInfo.top}px`,
    }"
  >
    <div class="element-content" :style="{ transform: `rotate(${elementInfo.rotate}deg)` }">
      <div
        v-if="currentChartImage"
        class="chart-image"
        :style="{ backgroundImage: `url('${currentChartImage}')` }"
      ></div>
      <div v-else class="mock-chart"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useSlidesStore } from '@/store'
import type { PPTDiagnosticChartElement } from '@/types/slides'

const props = defineProps<{ elementInfo: PPTDiagnosticChartElement }>()
const slidesStore = useSlidesStore()
const currentChartImage = computed(() => {
  const image = slidesStore.chartImages?.[props.elementInfo.id]
  return typeof image === 'string' && image.startsWith('data:image') ? image : null
})
</script>

<style scoped>
.diagnostic-chart-element {
  position: absolute;
}

.element-content,
.chart-image,
.mock-chart {
  width: 100%;
  height: 100%;
}

.chart-image {
  background: white center / contain no-repeat;
}

.mock-chart {
  background: white url('/images/mock-chart-diagnostic.svg') center / 100% 100% no-repeat;
}
</style>
